<template>
  <div>
    <form id="delete" @submit.prevent="showModal = true">
        <input type="submit" class="submit" v-bind:value="$t('admin.adminUserDelete.button.delete')">
    </form>
    <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('admin.adminUserDelete.modal.header')" @close="showModal = false">
      <p class="modal-text" v-html="$t('admin.adminUserDelete.modal.text')"></p>
      <a v-on:click.prevent="deleteUser" class="button" href="#">{{ $t("admin.adminUserDelete.modal.button") }}</a>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { adminService } from '@/services/admin.service'

export default {
  props: ['userId'],
  name: 'AdminUserDelete',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deleteUser: function(e) {
      e.preventDefault();
      adminService.userDelete(this.userId).then(() => {
        this.$router.push('/admin/')
      }).catch((err) => {
        console.error('Unable to delete user: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-text {
  font-weight: bold;
}
</style>
